export const DARK_MODE_SWITCH_TEST_ID = 'dark-mode-switch';
